export default "__VITE_ASSET__DNmzdHI$__"